var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPromotion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#78C91D",
  fillRule: "evenodd",
  d: "M4.286 13.5h6.428v-6H15L7.5.5 0 7.5h4.286z",
  clipRule: "evenodd"
})));
export default SvgPromotion;